import { NetrinService } from './../service/netrin.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import {
  PoBreadcrumb, PoLookupColumn, PoModalAction, PoModalComponent, PoNotification, PoNotificationService, PoPageAction, PoPageFilter,
  PoTableColumn, PoTableComponent } from '@po-ui/ng-components';

import { FiltroDadosParceiroDeNegocio } from '../interface/filtro-dados-cliente-fornecedor';
import { defaultParceiroDeNegocioAtualizar, ParceiroDeNegocio, ParceiroDeNegocioAtualizar } from '../interface/dados-cliente-fornecedor';
import { AuthService } from 'src/app/service/auth.service';
import { FornecedorLookupService } from 'src/app/service/fornecedor-lookup-service';
import { ClienteLookupService } from 'src/app/service/cliente-lookup-service';


@Component({
  selector: 'app-administrativo-netrin-consulta-api',
  templateUrl: './administrativo-netrin-consulta-api.component.html',
  styleUrls: ['./administrativo-netrin-consulta-api.component.css']
})

export class AdministrativoNetrinConsultaApiComponent implements OnInit {

  tabelaPrimariaDados: Array<ParceiroDeNegocio> = [];
  tabelaPrimariaFiltro: FiltroDadosParceiroDeNegocio = new FiltroDadosParceiroDeNegocio(this.authService, 'AdministrativoNetrinConsultaApiComponent');

  dadosParceiroDeNegocioAtualizar: ParceiroDeNegocioAtualizar = defaultParceiroDeNegocioAtualizar();

  fornecedorColumnsFilters: Array<PoLookupColumn> = this.fornecedorLookupService.getColumnsFilter();
  clientecolumnsFilters: Array<PoLookupColumn> = this.clienteLookupService.getColumnsFilter();

  constructor(
    public fornecedorLookupService: FornecedorLookupService,
    public clienteLookupService: ClienteLookupService,
    private authService: AuthService,
    private netrinService: NetrinService,
    private poNotificationService: PoNotificationService,
  ) { }

  @ViewChild('modalDadosBusca', { static: false }) modalDadosBusca!: PoModalComponent;
  @ViewChild('poTabelaPrincipal', { static: false }) poTabelaPrincipal!: PoTableComponent;
  @ViewChild('modalFiltroAvancadoTabelaPrincipal', { static: true }) modalFiltroAvancadoTabelaPrincipal!: PoModalComponent;

  public readonly poPageBreadcrumb: PoBreadcrumb = {
    items: [
      { label: 'Início', link: '/' },
      { label: 'Administrativo', },
      { label: 'Netrin', },
      { label: 'Consulta Cadastro (Cliente e Fornecedor)' }
    ]
  };

  public readonly poPoPageFilter: PoPageFilter = {
    advancedAction: ()=> this.modalFiltroAvancadoTabelaPrincipal.open()
  }

  public readonly poPageActions: Array<PoPageAction> = [
    { label: 'Iniciar Busca', icon: 'po-icon-refresh', action: this.abrirModalBuscaDados.bind(this)}
  ];

  public readonly  tabelaPrimariaColumns: Array<PoTableColumn> = [
    {property: 'CTIPO'       , label: 'Tipo' , width: '10%' , type: 'label' , labels: [
      {value: 'C', color: '#00c9b5', label: 'Cliente'},
      {value: 'F', color: '#00c983', label: 'Fornecedor'}
    ]},
    {property: 'CCODIGO'     , label: 'Código'              , type: 'number', width: '10%'},
    {property: 'CLOJA'       , label: 'Loja'                , width: '10%'  },
    {property: 'CNOME'       , label: 'Nome'                , width: '30%'  },
    {property: 'CNREDUZ'     , label: 'Nome Reduzido'       , width: '20%'  },
    {property: 'CCGC'        , label: 'CNPJ/CPF'            , width: '15%'  },
    {property: 'DULTCOM'     , label: 'Última Compra/Venda' , type: 'date'  , width: '15%'},
    {property: 'DATU'        , label: 'Última Atu.' , type: 'date'  , width: '15%'},
  ];

  ngOnInit() {
    this.loadDados();
  }


  loadDados() {
    this.netrinService.getClienteFornecedorLista(this.tabelaPrimariaFiltro.dados).subscribe((res) => {
      this.tabelaPrimariaDados = [...res.items];
    });
  }

  abrirModalBuscaDados(): void {
    this.dadosParceiroDeNegocioAtualizar.AITENS = this.poTabelaPrincipal.getSelectedRows() as Array<ParceiroDeNegocio>;

    if (this.dadosParceiroDeNegocioAtualizar.AITENS.length === 0) {
      this.poNotificationService.warning("Selecione ao menos um registro.");
    } else {
      this.modalDadosBusca.open()
    }
  }

  buscarDadosNetrin(): void {
    this.modalDadosBusca.close();

    this.poTabelaPrincipal.unselectRows();

    if (this.dadosParceiroDeNegocioAtualizar.AITENS.length === 0) {
      this.poNotificationService.warning("Selecione ao menos um registro.");
    } else {
      this.netrinService.postConsultarClienteFornecedor(this.dadosParceiroDeNegocioAtualizar).subscribe(()=>{
        this.dadosParceiroDeNegocioAtualizar = defaultParceiroDeNegocioAtualizar();
      });
    }
  }


  public readonly modalFiltroAvancadoTabelaPrincipalActions: PoModalAction = {
    label: 'Aplicar Filtros',
    action: ()=> {
      this.modalFiltroAvancadoTabelaPrincipal.close();
      this.loadDados();
    }
  }
}
